import { ThemeProvider } from '@mui/material/styles';
import { Box, GlobalStyles } from '@mui/material';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import type { RootState } from '@/store';
import { lightTheme, darkTheme } from '@/theme';
import Layout from '@/components/common/Layout';
import CategoriesPage from '@/components/playbooks/CategoriesPage';
import PlaybookViewer from '@/components/playbooks/PlaybookViewer';
import SpecsPage from '@/components/specs/SpecsPage';
import SpecViewer from '@/components/specs/SpecViewer';
import PropertiesPage from '@/components/properties/PropertiesPage';

function App() {
  const theme = useSelector((state: RootState) => state.ui.theme);
  const currentTheme = theme === 'light' ? lightTheme : darkTheme;

  return (
    <ThemeProvider theme={currentTheme}>
      <GlobalStyles
        styles={{
          'html, body, #root': {
            width: '100%',
            maxWidth: '100%',
            overflowX: 'hidden',
          },
        }}
      />
      <Box sx={{ display: 'flex', minHeight: '100vh', width: '100%', maxWidth: '100%', overflowX: 'hidden' }}>
        <Layout>
          <Routes>
            {/* Default redirect */}
            <Route path="/" element={<Navigate to="/properties" replace />} />
            
            {/* Categories and playbooks */}
            <Route path="/categories" element={<CategoriesPage />} />
            <Route path="/category/:categoryId" element={<PlaybookViewer />} />
            
            {/* Specifications */}
            <Route path="/specs" element={<SpecsPage />} />
            <Route path="/spec/:lotId" element={<SpecViewer />} />

            {/* Property Registry */}
            <Route path="/properties" element={<PropertiesPage />} />

            {/* Catch all - redirect to categories */}
            <Route path="*" element={<Navigate to="/properties" replace />} />
          </Routes>
        </Layout>
      </Box>
    </ThemeProvider>
  );
}

export default App;
